@if (item?.command) {
  <a
    mat-list-item
    [emBindCommand]="item?.command"
    [disabled]="disabled"
    [class.active-list-item]="item?.isActive"
    (click)="itemClicked.emit(item)"
  >
    @if (item?.iconName) {
      <mat-icon matListItemIcon>{{ item?.iconName }}</mat-icon>
    }
    @if (item?.iconImage && !item?.iconName) {
      <img matListItemIcon [src]="item?.iconImage" class="item-icon" />
    }
    <span matListItemLine>{{ item?.title | translate }}</span>
  </a>
  @if (item?.isBeta) {
    <div class="beta-tag">BETA</div>
  }
} @else {
  @if (item?.targetPath) {
    <a
      mat-list-item
      [routerLink]="item?.targetPath"
      [class.active-list-item]="item?.isActive"
      [disabled]="disabled"
      (click)="itemClicked.emit(item)"
    >
      @if (item?.iconName) {
        <mat-icon matListItemIcon>{{ item?.iconName }}</mat-icon>
      }
      @if (item?.iconImage && !item?.iconName) {
        <img matListItemIcon [src]="item?.iconImage" class="item-icon" />
      }
      <span
        matListItemLine
        [matTooltip]="item?.title | translate"
        [matTooltipShowDelay]="1000"
        matTooltipPosition="right"
        >{{ item?.title | translate }}</span
      >
    </a>
  }
  @if (!item?.targetPath) {
    <a
      mat-list-item
      [disabled]="disabled"
      [ngClass]="{'nested-item-active': item?.isActive || openSubList}"
      (click)="openSubList = !openSubList"
    >
      @if (item?.iconName) {
        <mat-icon matListItemIcon>{{ item?.iconName }}</mat-icon>
      }
      @if (item?.iconImage && !item?.iconName) {
        <img matListItemIcon [src]="item?.iconImage" class="item-icon" />
      }
      <span
        matListItemLine
        class="flex"
        [matTooltip]="item?.title | translate"
        [matTooltipShowDelay]="1000"
        matTooltipPosition="right"
        >{{ item?.title | translate }}
      </span>
    </a>
  }
  @if (item?.isBeta) {
    <div class="beta-tag">BETA</div>
  }
  @if (!hideNested && item?.items?.length && (item?.isActive || openSubList)) {
    <div class="sub-list-wrapper" [@expandCollapse]>
      <mat-nav-list class="sub-list">
        @for (subItem of item?.items; track subItem.title) {
          <em-nav-item
            [item]="subItem"
            [disabled]="disabled"
            (click)="itemClicked.emit(item)"
          ></em-nav-item>
        }
      </mat-nav-list>
    </div>
  }
}
